import { Controller } from "react-hook-form";

import { withShowIf } from "../../../../../../components/with-show-if/with-show-If.component";

import { StyledSelect } from "./buy-get-select.styles";
import { BuyGetSelectProps } from "./buy-get-select.props";

export const BuyGetSelect = withShowIf((props: BuyGetSelectProps) => {
  return (
    <Controller
      control={props.control}
      name={`${props.name}` as const}
      render={(render) => (
        <StyledSelect
          {...render.field}
          error={props.hasError}
          multiple={!!props.multiple}
          onChange={(event) => {
            props.onChange && props.onChange(event);
            render.field.onChange(event);
          }}
        >
          {props.children}
        </StyledSelect>
      )}
    />
  );
});
